module.exports = __webpack_public_path__ + "img/11.3facb0d8.png";